import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcDateFormat',
  standalone: false,
})
export class UtcDateFormatPipe implements PipeTransform {
  /**
   * Convert to UTC Date string to a UTC format.
   * @param utcdate pass the incoming date string to be transformed
   * @returns the UTC date
   */
  public transform(utcdate: string): Date {
    if (utcdate) {
      // NOTE: Need to handle issue with Mac Safari not able to format date string properly for pipe.
      // This is a non-issue for Chrome, FF, non-Safari browsers.
      const formatDateString = utcdate.replace(/\s/g, 'T') + 'Z';
      const date = new Date(formatDateString);
      const formattedUTCDate = new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      );
      return formattedUTCDate;
    }
  }
}
